export const environment = {
  production: false,
  env: 'dev',
  apiUrl: 'https://api-staging.caremessenger.co.uk/v2',
  pusherKey: '2dd7fcb4e455b0869e43'
};
